<template>
  <div class="index">
       <!-- 背景图 -->


       <div class="banner">
           <div class="logo">
                <img src="../../assets/img/index/logo.png"/>
            </div>
            <div class="share_icon" @click="$router.push({path:'/share'})">
                <img src="../../assets/img/index/share_icon.png"/>
                <span>分享</span>
            </div>
            <van-swipe class="swiper-box"
                :autoplay="3000"
                indicator-color="#fff"
            >
                <van-swipe-item  class="swiper-box-item" v-for="item in slideData" :key="item.adv_id">
                    <img :src="item.adv_image" :alt="item.adv_title"/>
                </van-swipe-item>
                <!-- <van-swipe-item  class="swiper-box-item">
                    <img src="../../assets/img/index/banner2.png" />
                </van-swipe-item>
                 <van-swipe-item  class="swiper-box-item">
                    <img src="../../assets/img/index/banner1.png" />
                </van-swipe-item> -->
            </van-swipe>
           <!-- <img src="../../assets/img/index/background.png"/>  -->
       </div>


        <!--分享公告-->
        <div class="notice">
            <img src="../../assets/img/index/notice_icon.png" alt=""/>
            <van-notice-bar
                class="notice-bar"

                text="分享XMI，立享用户入金百分之10反佣"></van-notice-bar>
        </div>
         <!--中间导航-->
        <ul class="menu">
            <li class="menu-item" @click="goPage('/recharge')">
                <img src='../../assets/img/index/recharge.png'/>
                <p>充币</p>
            </li>
            <li class="menu-item" @click="goPage('/withdraw')">
                <img src='../../assets/img/index/extract.png'/>
                <p>提币</p>
            </li>
            <li class="menu-item" @click="goPage('/inviteCode')">
                <img src='../../assets/img/index/invite.png'/>
                <p>邀请好友</p>
            </li>
            <li class="menu-item" @click="goPage('/myMiner')">
                <img src='../../assets/img/index/miner.png'/>
                <p>我的矿机</p>
            </li>
        </ul>
        <!--广告-->
        <div class="advertise" @click="$router.push({path: '/announcement', query: {id: 21}})">
             <img src="../../assets/img/index/myAdvertise.png" alt=""/>
        </div>
        <div class="miner">
            <h3 class="miner-title">矿机</h3>
            <ul>
               <li class="miner-item" v-for="(item,index) in goods" :key="item.type">
                    <img :src="require(`../../assets/img/index/miner${index+1}.png`)" class="miner-image"/>
                   <div class="miner-item-center">
                       <p class="desc">{{item.good_name}}{{item.day}}天</p>
                       <div class="miner-num">
                           <dl>
                                <dt class="all">{{item.all_num}}XMI</dt>
                                <dd>总产量</dd>
                            </dl>
                            <dl>
                                <dt>{{item.price}}</dt>
                                <dd>租金</dd>
                            </dl>
                            <dl>
                                <dt>{{item.computing}}G</dt>
                                <dd>算力</dd>
                            </dl>
                       </div>
                   </div>
                   <div class="miner-item-right">
                        <p class="limit">限租{{item.limit}}台</p>
                        <p class="limit-bg"></p>
                        <button class="btn" type="primary" @click="goDetail(item,index)">租用</button>
                   </div>
                </li>
            </ul>
        </div>
        <Tabbar active="index"></Tabbar>
         <!--密码框-->
        <!-- <van-dialog
                v-model="showBuyComifrm"
                title="租用"
                show-cancel-button
                @confirm="buyMiner"
                @cancel="cancelEvent">
                <div class="dialog-content">
                      <p class="dialog-text">{{current.good_name}}{{current.day}}天<span>限租{{current.limit}}台</span></p>
                      <input type="password" placeholder="请输入交易密码" class="pwdInput" v-model="pay_password" autocomplete="off"/>
                </div>
          
        </van-dialog> -->
  </div>
</template>

<script>
import Tabbar from '../../components/tabbar'
import { mapState,mapActions } from 'vuex'
export default {
    name: "index",
     components: {
            Tabbar
        },
    data(){
        return {
           slideData:[],
           goods:[],
           current:{},
           showBuyComifrm:false,
           pay_password:'',
        }
    },
    created(){
      this.getData()
      this.getUserInfo()
    },
    computed:{
       ...mapState(['userInfo','isLogin'])
    },

    methods:{
        getData(){
          this.ajax.post('appapi/index/indexData').then((res)=>{
            console.log(res.data)
            let data = res.data.data
            if(res.data.code === 1 ){
              this.slideData = data.slide
              this.goods = data.goods
            }
          })
        },
        goPage(path){
            this.$router.push({path:path})
        },
        goDetail(item,index){
          let query = {
            good_name: item.good_name,
            good_id:item.good_id,
            day:item.day,
            limit:item.limit,
            index:index
          };
           // this.$toast("暂未开放");
            console.log(query);
            this.$router.push({path:'/pintuan',query:query})
        },
        comfirmBuy(item){
          this.showBuyComifrm = true
          this.current = item
        },
        cancelEvent() {
            this.pay_password = "";
        },
        buyMiner(){

          this.ajax.post('/appapi/miner/buy',{
            good_id:this.current.good_id,
            pay_password:this.pay_password
          }).then((res)=>{
            if(res.data.code===1){
              this.$toast(res.data.msg|| '购买成功')
            }
          })
        },
        ...mapActions(['getUserInfo'])
    }
}
</script>

<style lang="scss">
.index{
    position: relative;
    padding-bottom:98px;
    overflow: hidden;
    .banner{
        background: url(../../assets/img/background.png) no-repeat 0 0;
        background-size: 100%;
        width:100%;
        padding:70px 0 44px;
        position: relative;
        .logo{
            width:200px;
            margin:0 auto 40px;
        }
        .share_icon{
            width:142px;
            height:52px;
            border-radius:40px;
            position: absolute;
            top:87px;
            right:-20px;
            color:#07A651;
            font-size:24px;
            @include flex($cross:center);
            background: #fff;
            img{
                width:28px;
                height:28px;
                margin:0 12px 0 18px;
            }
        }
    }

    .swiper-box{
        width:100%;
        height:269.8px;
        &-item{
            padding:0 30px;
        }
        /deep/ .van-swipe__indicator--active{
            width: 24px !important;
            border-radius: 20px !important;
        }
    }
    .notice{
          position: relative;
           @include flex($cross:center);
            height: 62px;
            padding: 0 40px;
           font-size:24px;

           img {
                left: 30px;
                width: 30px;
                margin-right:5px;
            }
            &-bar {
                flex: 1;
                 height: 62px;
                background: #FAFAFA;
                color:#666666;
            }
    }
    .menu{
        @include flex($main:space-between);
        padding:0 30px;
        margin-bottom:52px;
        &-item{
            img{
                width:108px;
            }
            text-align: center;
            font-size:24px;
            color:#333333;
        }

    }
    .advertise{
        padding:0 30px;
        height:140px;
        border-radius:20px;

        margin-bottom:45px;
    }
    .miner{
        padding:0 30px;
        ul{
            margin-bottom:10px;
        }
        &-item{
            @include flex($main:space-between);
            position:relative;
            padding:18px 0;
            &::after{
              border:1PX solid #EFF0F1;
              content:'';
              position: absolute;
              box-sizing: border-box;
              bottom:0;
              left:37%;
              width:65%;
            }
            &-center{
                margin-left:32px;
                font-weight:bold;
                color:#4F5668;
                flex:1;

                .desc{
                    font-size:28px;
                    margin-bottom:26px;
                }
                .miner-num{
                     @include flex($main:space-around);
                     font-size:28px;
                     dl{
                        // margin-right:40px;
                        text-align: center;
                     }
                     dt.all{
                        color: #DF5334;
                     }
                     dd{
                         font-size:22px;
                         font-weight:500;
                         color:#B9C4D3;
                         margin-top:16px;
                     }
                }
            }
            &-right{
                text-align: center;
                .limit{
                    color:#10914A;
                    font-size:22px;
                    font-weight:500;
                }
                .limit-bg{
                    opacity:0.8;
                    height:13px;
                    background-image: linear-gradient(to right, #d7eedf , #fff);
                     margin:-10px 0 29px 10px;
                }
                .btn{
                     width:118px;
                    height:50px;
                    color:#fff;
                    background:rgba(14,193,94,1);
                    border-radius:25px;
                    font-size:26px;
                    line-height: 50px
                }
            }

        }
        &-title{
            font-size:38px;
            padding-left:8px;
            margin-bottom:10px;
            font-weight:bold;
        }
        &-image{
            width:223px;
            height:167px;
            border:1Px solid #ddd;
        }

    }


}

</style>
